import { CatalogGeoLocationComparators } from 'modules/queryBuilder/renderers/condition/comparator/constants';
import { FieldType } from 'modules/queryBuilder/types';
import { isObject } from 'utils/helpers';

export const transformIsWithinGeoLocationCondition = <Condition extends Record<string, unknown>>({
  value,
  comparatorType,
  ...restOfCondition
}: Condition) =>
  restOfCondition.fieldType === FieldType.GEO_LOCATION &&
  comparatorType === CatalogGeoLocationComparators.IS_WITHIN &&
  isObject(value)
    ? {
        ...restOfCondition,
        ...value,
        comparatorType,
        value: '',
      }
    : { value, comparatorType, ...restOfCondition };
